const routes = {
	ROOT: '/',
	LOGIN: '/login',
	OUTBOX: '/outbox',
	SENDBOX: '/sendbox',
};

export default routes;
